<template>
  <div class="login-container">
    <el-form class="card-box login-form" autoComplete="on" :model="loginForm" :rules="loginRules" ref="loginForm" label-position="left">
      <h3 class="title">系统登录</h3>

      <el-form-item prop="UserName">
        <span class="svg-container svg-container_login">
          <!-- <icon-svg icon-class="yonghuming" /> -->
          <i class="iconfont icon-yonghu"></i>
        </span>
        <el-input name="UserName" type="text" v-model.trim="loginForm.UserName" autoComplete="on" placeholder="用户名" />
      </el-form-item>

      <el-form-item prop="Password">
        <span class="svg-container">
          <!-- <icon-svg icon-class="mima" /> -->
          <i class="iconfont icon-mima"></i>
        </span>
        <el-input name="Password" :type="pwdType" @keyup.enter.native="handleLogin" v-model.trim="loginForm.Password" autoComplete="on"
          placeholder="密码" />
        <span class='show-pwd' @click='showPwd'>
             <!--<icon-svg icon-class="yanjing" />--> 
             <i class="iconfont icon-icon_closeeye"></i>
        </span>
      </el-form-item>

      <el-button id="btn_post" type="primary" style="width:100%;margin-bottom:30px;" :loading="loading" :disabled="loading" @click.native.prevent="handleLogin">登录</el-button>

      <!-- <div class='tips'>账号:admin 密码随便填</div>
      <div class='tips'>账号:editor  密码随便填</div> -->
    </el-form>

  </div>
</template>

<script>
// import { isvalidUsername } from '@/utils/validate'
// import socialSign from './socialsignin'
import { setToken } from '@/utils/auth'
export default {
//   components: { socialSign },
  name: 'login',
  data() {
       const validateUsername = (rule, value, callback) => {
         if (value.trim().length<2) {
           callback(new Error('请输入正确的用户名'))
         } else {
           callback()
         }
       }
       const validatePassword = (rule, value, callback) => {
         if (value.length < 6) {
           callback(new Error('密码不能小于6位'))
         } else {
           callback()
         }
       }
    return {
      loginForm: {
        UserName: '',
        Password: ''
      },
      loginRules: {
        UserName: [{ required: true, trigger: 'change', validator: validateUsername }],
        Password: [{ required: true, trigger: 'change', validator: validatePassword }]
      },
      pwdType: 'password',
      loading: false,
      showDialog: false
    }
  },
  methods: {
    showPwd() {
      if (this.pwdType === 'password') {
        this.pwdType = ''
      } else {
        this.pwdType = 'password'
      }
    },
    handleLogin() {
      
        var _this = this;
        _this.$refs.loginForm.validate(valid => {
        if (valid) {
          _this.loading = true;
          _this.server.post("/Token/Login", _this.loginForm).then(function(res){
            _this.loading = false;
            if(res.data.State==1){
              let token = "bearer "+res.data.Data.accessToken
              setToken(token)
              
              if(_this.$route.query.redirect){
                _this.$router.push({ path: _this.$route.query.redirect })
              }else{
                _this.$router.push({ path: '/dashboard' })
              }
            }
          }).catch(()=>{
          	_this.loading=false;
          })
        //   this.$store.dispatch('LoginByUsername', this.loginForm).then(() => {
        //     this.loading = false
        //     this.$router.push({ path: '/' })
        //         // this.showDialog = true
        //   }).catch(() => {
        //     this.loading = false
        //   })

        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    afterQRScan() {
          // const hash = window.location.hash.slice(1)
          // const hashObj = getQueryObject(hash)
          // const originUrl = window.location.origin
          // history.replaceState({}, '', originUrl)
          // const codeMap = {
          //   wechat: 'code',
          //   tencent: 'code'
          // }
          // const codeName = hashObj[codeMap[this.auth_type]]
          // if (!codeName) {
          //   alert('第三方登录失败')
          // } else {
          //   this.$store.dispatch('LoginByThirdparty', codeName).then(() => {
          //     this.$router.push({ path: '/' })
          //   })
          // }
    }
  },
  created() {
        // window.addEventListener('hashchange', this.afterQRScan)
  },
  destroyed() {
        // window.removeEventListener('hashchange', this.afterQRScan)
  }
}
</script>

<style rel="stylesheet/scss" lang="scss">
  @import "src/styles/mixin.scss";
  $bg:#2d3a4b;
  $dark_gray:#889aa4;
  $light_gray:#eee;

  .login-container {
    @include relative;
    height: 100vh;
    background-color: $bg;
    input:-webkit-autofill {
      -webkit-box-shadow: 0 0 0px 1000px #293444 inset !important;
      -webkit-text-fill-color: #fff !important;
    }
    input {
      background: transparent;
      border: 0px;
      -webkit-appearance: none;
      border-radius: 0px;
      padding: 12px 5px 12px 15px;
      color: $light_gray;
      height: 47px;
    }
    .el-input {
      display: inline-block;
      height: 47px;
      width: 85%;
    }
    .tips {
      font-size: 14px;
      color: #fff;
      margin-bottom: 10px;
    }
    .svg-container {
      padding: 6px 5px 6px 15px;
      color: $dark_gray;
      vertical-align: middle;
      width: 30px;
      display: inline-block;
      &_login {
        font-size: 20px;
      }
    }
    .title {
      font-size: 26px;
      font-weight: 400;
      color: $light_gray;
      margin: 0px auto 40px auto;
      text-align: center;
      font-weight: bold;
    }
    .login-form {
      position: absolute;
      left: 0;
      right: 0;
      width: 400px;
      padding: 35px 35px 15px 35px;
      margin: 120px auto;
    }
    .el-form-item {
      border: 1px solid rgba(255, 255, 255, 0.1);
      background: rgba(0, 0, 0, 0.1);
      border-radius: 5px;
      color: #454545;
    }
    .show-pwd {
      position: absolute;
      right: 10px;
      top: 7px;
      font-size: 16px;
      color: $dark_gray;
      cursor: pointer;
    }
    .thirdparty-button{
      position: absolute;
      right: 35px;
      bottom: 28px;
    }
  }
</style>
